import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import { FastCheckoutActions } from './fastCheckout.actions';
import { FastCheckoutResetAction, FastCheckoutUpdateAction, IProductState, IState } from './fastCheckout.types';

export const initialState: IState = {
    isCheckoutProcessing: false,
    productState: {},
};

const initialProductState: IProductState = {
    isLoading: false,
    isLoaded: false,
    hasError: false,
    checkoutLink: null,
};

export const fastCheckoutReducer = createReducer(initialState, {
    [FastCheckoutActions.reset.type]: (state, action: PayloadAction<FastCheckoutResetAction>) => {
        const id = action.payload.id;

        if (!id) {
            state = initialState;
        } else {
            state = { ...state };
            delete state[id];
        }
    },
    [FastCheckoutActions.update.type]: (state, action: PayloadAction<FastCheckoutUpdateAction>) => {
        const { id, data, isCheckoutProcessing } = action.payload;

        return {
            ...state,
            isCheckoutProcessing,
            productState: {
                ...state.productState,
                [id]: {
                    ...initialProductState,
                    ...data,
                },
            },
        };
    },
});
